export interface AuthConfig {
    USERS_COLLECTION: string;
}

const authConfig: AuthConfig = {
    USERS_COLLECTION: "customers",
}
export default authConfig;